import camelcaseKeys from 'camelcase-keys';

import { baseApi } from 'api/api-base';
import { API_ROUTES } from 'constants/api-routes';
import { GetMyTasks, ResolveMyTask } from 'types/api/api-tasks.types';

// Customer tasks (Tasks page): list the logged-in customer's tasks and mark one resolved.
// Tag-based invalidation refetches the list after a resolve.
const taggedBaseApi = baseApi.enhanceEndpoints({ addTagTypes: ['MyTasks'] });

export const tasksApi = taggedBaseApi.injectEndpoints({
  endpoints: builder => ({
    getMyTasks: builder.query<GetMyTasks.ResponseType, GetMyTasks.RequestType>({
      query: () => ({
        url: API_ROUTES.GET_MY_TASKS,
      }),
      providesTags: ['MyTasks'],
      extraOptions: {},
      transformResponse: (response: GetMyTasks.RawApiResponse): GetMyTasks.ResponseType =>
        camelcaseKeys(response as unknown as Record<string, unknown>, {
          deep: true,
        }) as unknown as GetMyTasks.ResponseType,
    }),
    resolveMyTask: builder.mutation<ResolveMyTask.ResponseType, ResolveMyTask.RequestType>({
      query: id => ({
        url: `${API_ROUTES.GET_MY_TASKS}/${id}/resolve`,
        method: 'PUT',
      }),
      invalidatesTags: ['MyTasks'],
      extraOptions: {},
      transformResponse: (response: ResolveMyTask.RawApiResponse): ResolveMyTask.ResponseType =>
        camelcaseKeys(response as unknown as Record<string, unknown>, {
          deep: true,
        }) as unknown as ResolveMyTask.ResponseType,
    }),
  }),
});

export const { useGetMyTasksQuery, useResolveMyTaskMutation } = tasksApi;
